import { render, staticRenderFns } from "./taskSteps.vue?vue&type=template&id=b3125670&scoped=true"
import script from "./taskSteps.vue?vue&type=script&lang=js"
export * from "./taskSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3125670",
  null
  
)

export default component.exports